import { useQuery } from 'react-query';

import { canCustomizeLinkPosts } from '~/api/routes/domainVerification';

import { useStateBus } from '~/state/bridge';
import { getCurrentLink } from '~/state/Campaign/selectors';

import { usePageQuery } from './usePageQuery';

export function useDomainVerificationQuery() {
  const link = useStateBus(getCurrentLink);
  const [page] = usePageQuery();

  return useQuery(['domain-verification', link, page], () => canCustomizeLinkPosts(link, page), {
    enabled: !!page && !!link,
  });
}
